import { render, staticRenderFns } from "./ReplacementList.vue?vue&type=template&id=7c3d960c&"
import script from "./ReplacementList.vue?vue&type=script&lang=js&"
export * from "./ReplacementList.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports